import React from 'react';
//Componentes importados de material ui
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Grid, MuiThemeProvider, FormLabel } from '@material-ui/core';
//Estilo importado
import Style from './RadioButtonStyle';

/**
 * 
 * @function RadioButton
 * Función que contiene los componentes Grid, FormControl, InputLabel, RadioGroup, FormControlLabel, Radio, MuiThemeProvider
 * El componente FormControl contiene el componenteRadioButton en si
 * El componente FormLabel contiene el título de la etiqueta del componente FormControl
 * El componente RadioGroup agrupa las opciones del componenteRadioButton
 * El componente FormControlLabel contiene las opciones del componenteRadioButton
 * El componente Radio contiene la opción y su etiqueta label
 * @param props
 * A través d elas props se reciben los atributos y propiedades
 */
export default function RadioButton(props) {
    return (
        <MuiThemeProvider theme={Style}>
            <Grid
                container
                className={props.classes.classGrid}
                id={props.idGrid}
            >
                <FormControl
                    className={props.classes.classFormControlLabel}
                    component={props.componentFormControl}
                >
                {
                    props.isRequired &&
                        <Grid container>
                            <FormLabel
                                shrink='true'
                                component={props.componentFormLabel}
                                className={props.classFormLabel}
                            >
                            {props.title}
                            </FormLabel>
                            <span className={props.classes.classSpanRequired}>{props.textRequired}</span>
                        </Grid>
                }
                {
                    !props.isRequired &&
                        <Grid container>
                            <FormLabel
                                shrink='true'
                                component={props.componentFormLabel}
                                className={props.classFormLabel}
                            >
                            {props.title}
                            </FormLabel>
                            <span className={props.classes.classSpanRequired}>{props.textRequired}</span>
                        </Grid>
                }                     
                    <RadioGroup
                        aria-label={props.ariaLabel}
                        id={props.id}
                        name={props.name}
                        value={props.value}
                        onChange={props.onChange}
                        required={props.isRequired}
                        aria-required={props.isRequired}
                    >
                        {
                            props.options.map((element, index) => (
                                <FormControlLabel
                                    control={<Radio id={element.id}/>}
                                    name="Sexo"
                                    value={JSON.stringify(element)} // DOM CAST VALUE TO STRING
                                    label={element.descripcion}
                                    key={index.toString()}
                                    inputRef={props.inputRef}
                                    tabIndex='0'
                                />
                                
                            ))
                        }
                    </RadioGroup>
                </FormControl>
                <FormHelperText>{props.FormHelperText}</FormHelperText>
            </Grid>
        </MuiThemeProvider>
    );
}